import styled from 'styled-components/macro'
import { theme } from 'styled-tools'

const Counter = styled.div`
  color: ${theme('stockBannerText')};
  background-color: ${theme('stockBannerBackground')};
  font-size: 0.8125rem;
  padding: 0.2rem 0.35rem;
  text-transform: uppercase;
`

export { Counter }
